// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Sustainability from '../_raw/service/icon_sustainability.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Sustainability);
